import ConfirmationPopup from './ConfirmationPopupContainer';
export default ConfirmationPopup;
